module.exports = __webpack_public_path__ + "assets/img/index-partner15.230cdb2f.jpg";